import store from '@/store'

export const projectInfoList = [
  {
    label: '项目状态',
    value: '项目状态',
    realValue: '项目状态'
  },
  {
    label: '{项目状态内容}',
    value: '#projectStatus#',
    realValue: store.getters.projectItem.projectStatusName
  },
  {
    label: '项目类型',
    value: '项目类型',
    realValue: '项目类型'
  },
  {
    label: '{项目类型内容}',
    value: '#projectType#',
    realValue: store.getters.projectItem.projectTypeName
  },
  {
    label: '负责人',
    value: '负责人',
    realValue: '负责人'
  },
  {
    label: '{负责人内容}',
    value: '#managerName#',
    realValue: store.getters.projectItem.managerName
  },
  {
    label: '联系电话',
    value: '联系电话',
    realValue: '联系电话'
  },
  {
    label: '{联系电话内容}',
    value: '#managerPhone#',
    realValue: store.getters.projectItem.managerPhone
  },
  {
    label: '开工日期',
    value: '开工日期',
    realValue: '开工日期'
  },
  {
    label: '{开工日期内容}',
    value: '#startDate#',
    realValue: store.getters.projectItem.startDate
  },
  {
    label: '竣工日期',
    value: '竣工日期',
    realValue: '竣工日期'
  },
  {
    label: '{竣工日期内容}',
    value: '#endDate#',
    realValue: store.getters.projectItem.planEndDate
  },
  {
    label: '地址',
    value: '地址',
    realValue: '地址'
  },
  {
    label: '{地址内容}',
    value: '#address#',
    realValue: store.getters.projectItem.address
  }
]

export const siteCountList = [
  {
    label: '在岗人数',
    value: '在岗人数',
    realValue: '在岗人数'
  },
  {
    label: '{在岗人数内容}',
    value: '#onJobCount#',
    realValue: ''
  },
  {
    label: '进场人数',
    value: '进场人数',
    realValue: '进场人数'
  },
  {
    label: '{进场人数内容}',
    value: '#inCount#',
    realValue: '#inCount#'
  },
  {
    label: '出场人数',
    value: '出场人数',
    realValue: '出场人数'
  },
  {
    label: '{出场人数内容}',
    value: '#outCount#',
    realValue: '#outCount#'
  },
  {
    label: '场内人数',
    value: '场内人数',
    realValue: '场内人数'
  },
  {
    label: '{场内人数内容}',
    value: '#entryPersonAmount#',
    realValue: '#entryPersonAmount#'
  },
  {
    label: '劳务工人',
    value: '劳务工人',
    realValue: '劳务工人'
  },
  {
    label: '{劳务工人内容}',
    value: '#entryWorkerCount#',
    realValue: '#entryWorkerCount#'
  },
  {
    label: '管理人员',
    value: '管理人员',
    realValue: '管理人员'
  },
  {
    label: '{管理人员内容}',
    value: '#entryManagerCount#',
    realValue: '#entryManagerCount#'
  },
  {
    label: '出勤率',
    value: '出勤率',
    realValue: '出勤率'
  },
  {
    label: '{出勤率内容}',
    value: '#attendanceRate#',
    realValue: '#attendanceRate#'
  }
]
export const realTimeCountList = [
  {
    label: '实时人数',
    value: '实时人数',
    realValue: '实时人数'
  },
  {
    label: '{实时人数内容}',
    value: '#entryPersonAmount#',
    realValue: '#entryPersonAmount#'
  },
  {
    label: '管理人数',
    value: '管理人数',
    realValue: '管理人数'
  },
  {
    label: '{管理人数内容}',
    value: '#entryManagerCount#',
    realValue: '#entryManagerCount#'
  },
  {
    label: '劳务工人',
    value: '劳务工人',
    realValue: '劳务工人'
  },
  {
    label: '{劳务工人内容}',
    value: '#entryWorkerCount#',
    realValue: '#entryWorkerCount#'
  }
]
